let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l1pR0")).then(() => parcelRequire('jNMlH'));